module.exports = __webpack_public_path__ + "static/media/25.54ab22ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/25.jpg
// module id = 394
// module chunks = 0